import React, { useState } from "react";
import cx from "classnames";
import styles from "./PatientSelector.module.scss";
import { SessionExpiredToast } from "features/login/SessionExpiredToast";
import { Layout } from "features/layout";

export const ConfirmPatient: React.FC = () => {
  return (
    <Layout>
      <SessionExpiredToast />
      
    </Layout>
  );
};
